import { FormattedMessage } from "react-intl";
import { Wrapper } from "./copy-right.styles";

const CopyRight = () => {
  return (
    <Wrapper>
      <p>
        <FormattedMessage
          id="all.rights.reserved"
          defaultMessage="@2023 Copyright. All rights reserved"
        />
      </p>
    </Wrapper>
  );
};

export default CopyRight;
